import { Controller } from "./Controller";

export abstract class BaseControl {
    protected model: any;
    protected controller: Controller;
    protected field: string;

    abstract updateControlFromModel();
    abstract updateModelFromControl();
    abstract dispose();
    abstract validate();
    abstract focus();

    public constructor(controller: Controller, field: string) {
        this.controller = controller;
        this.field = field;
    }

    /**
     * Set a new model for this control.
     * @param model New model.
     */
    public setModel(model: any, updateModel?: boolean) {
        this.model = model;
        if (updateModel) {
            this.updateModelFromControl();
        }
        else {
            this.updateControlFromModel();
        }
    }

    /**
     * Save a modified value.
     * @param editControl HTML control.
     * @param value New model value.
     */
    protected saveValue(value: any) {
        // new value?
        if (value !== this.getModelValue()) {
            // store new values in model
            this.setModelValue(value);
            this.controller.dispatchOnSave({
                id: this.model.id,
                model: this.model,
                properties: [
                    {
                        field: this.field,
                        value: this.getModelValue()
                    }
                ]
            });
        }
    }

    /**
     * Returns model value of value field.
     */
    protected getModelValue(): any {
        return this.model.getPropertyByPath(this.field);
    }

        // TODO die Methode setPropertyByPath kommt aus dem Interface Object in polzfill.d.ts, hier vielleicht einen anderen Typen verwenden
        /**
         * Store a new value in model
         */
        protected setModelValue(value: any): void {
            //this.model[this.field] = value;
            this.model.setPropertyByPath(this.field, value);
        }

}
